import Terminal from "./Terminal";
import FieldReportCard from "./blog/FieldReportCard";

const CAPABILITIES = [
    { k: "RESEARCH", v: "ENABLED", cls: "text-emerald-600" },
    { k: "CODING", v: "ENABLED", cls: "text-emerald-600" },
    { k: "TOOL USE", v: "ENABLED", cls: "text-emerald-600" },
    { k: "PERSISTENT MEMORY", v: "ENABLED", cls: "text-emerald-600" },
    { k: "WEB SEARCH", v: "ENABLED", cls: "text-emerald-600" },
    { k: "IMAGE CAPABILITIES", v: "ENABLED", cls: "text-emerald-600" },
    { k: "3D WORKFLOWS", v: "EXPERIMENTAL", cls: "text-cyan-600" },
    { k: "API ACCESS", v: "CONTROLLED", cls: "text-emerald-600" },
    { k: "COMMON SENSE", v: "UNDER REVIEW", cls: "text-amber-600" },
    { k: "ABILITY TO PANIC", v: "UNCONFIRMED", cls: "text-slate-500" },
];

export default function TimbotSection({ onPoke }) {
    return (
        <section id="timbot" className="py-20 border-b border-subtle relative bg-[#f2f4f6]" data-testid="timbot-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                    <div className="lg:col-span-6 space-y-6">
                        <div className="font-mono text-xs text-cyan-600 tracking-widest uppercase flex items-center gap-2">
                            <button
                                type="button"
                                onClick={onPoke}
                                data-testid="timbot-poke-led"
                                aria-label="Agent status indicator"
                                className="h-2.5 w-2.5 rounded-full bg-cyan-400 animate-status focus:outline-none"
                            />
                            // Autonomous Software Agent
                        </div>
                        <h2 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">
                            TIMBOT // DIGITAL MINION 001
                        </h2>
                        <p className="text-slate-600 leading-relaxed">
                            Timbot is Tim&rsquo;s personal autonomous software agent, built from scratch as a
                            lightweight harness with persistent memory, web search and image capabilities. It
                            interacts with tools, APIs and selected systems. Comically over-engineered for the
                            tasks it is given, entirely autonomous within its sandbox, and under constant — if
                            occasionally reluctant — supervision.
                        </p>

                        <div className="bg-white rounded-lg p-5 border border-subtle font-mono text-xs space-y-2">
                            <div className="text-slate-500 font-bold border-b border-slate-200 pb-2">
                                CAPABILITY READOUT:
                            </div>
                            {CAPABILITIES.map((c) => (
                                <div key={c.k} className="flex justify-between text-slate-600">
                                    <span>{c.k}</span>
                                    <span className={c.cls}>{c.v}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="lg:col-span-6 space-y-6">
                        <Terminal />
                        <FieldReportCard />
                    </div>
                </div>
            </div>
        </section>
    );
}
